import { Controller } from "@hotwired/stimulus"

// Generic instant image preview for a file input. Scope one controller per
// upload slot: the box that displays the image is the "preview" target and the
// file input fires change->image-preview#preview. When the slot already shows
// a server-rendered <img>, its src is swapped so the existing styling is kept;
// otherwise the empty-state placeholder is replaced with a new <img> styled by
// the imgClass/imgStyle values and described by imgAlt.
export default class extends Controller {
  static targets = ["preview"]
  static values = {
    imgAlt: { type: String, default: "Preview" },
    imgClass: String,
    imgStyle: { type: String, default: "width: 100%; height: 100%; object-fit: cover;" }
  }

  connect() {
    this.initialPreviewHTML = this.previewTarget.innerHTML
  }

  preview(event) {
    const file = event.target.files[0]
    if (!file) {
      this.previewTarget.innerHTML = this.initialPreviewHTML
      return
    }
    if (!file.type.startsWith("image/")) return

    const reader = new FileReader()
    reader.onload = (e) => this._render(e.target.result)
    reader.readAsDataURL(file)
  }

  _render(dataUrl) {
    const existing = this.previewTarget.querySelector("img")
    if (existing) {
      existing.src = dataUrl
      return
    }

    const img = document.createElement("img")
    img.src = dataUrl
    img.alt = this.imgAltValue
    if (this.imgClassValue) {
      img.className = this.imgClassValue
    } else {
      img.style.cssText = this.imgStyleValue
    }
    this.previewTarget.replaceChildren(img)
  }
}
